export default "{\n    \"save\": \"Guardar\",\n    \"cancel\": \"Cancelar\",\n    \"edit\": \"Editar\"\n}\n"